import { render, staticRenderFns } from "./GuestScreenshots.vue?vue&type=template&id=40d58c6e&scoped=true&"
import script from "./GuestScreenshots.vue?vue&type=script&lang=js&"
export * from "./GuestScreenshots.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d58c6e",
  null
  
)

export default component.exports